import styled from 'styled-components';
import { Input as ANTDInput } from 'antd';

export const Container = styled.div`
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const Input = styled(ANTDInput.Search)`
    flex-direction: row;
    background-color: #e9ecf2;
    border-radius: 8px;
    width: 100%;
    height: 42px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    color: #6b7384;
    outline: 0;
    border: 0;
    box-shadow: 0 0 0 0;

    .ant-input-group-addon{
        height: 42px;
    }

    .ant-btn-primary {
        background-color: #2e3c50;
        border-color: #2e3c50;
    }

    .ant-btn-primary:hover, .ant-btn-primary:focus {
        box-shadow: unset;
        background-color: #525d6e;
        border: solid 1px #525d6e;
        color: #ffffff;
    }

    .ant-input-clear-icon {
        color: red;
        background-color: #e9ecf2;
    }

`;

export const ErrorText = styled.div`
    color: #f10b3c;
    font-style: normal;
    font-weight: 300;
    font-size: 10px;
    line-height: 12px;
    padding: 2px 16px;
`;